export default __webpack_public_path__ + "static/media/Ramaiah.ef9d0942.png";